import { useEffect } from "react";

export const useMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, content, attr = "content") => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const parts = selector.match(/\[(\w+)="([^"]+)"\]/);
        if (parts) el.setAttribute(parts[1], parts[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, content);
    };

    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', title);
    }
  }, [title, description]);
};

export const useSchema = (schema) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const schemaString = JSON.stringify(schema);
  useEffect(() => {
    const id = "ld-json-schema";
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    if (!schema) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = schemaString;
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [schemaString]);
};
